import React, { useEffect, useRef, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextBoard } from "../../context/ContextBoard";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import $ from "jquery";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { motion, AnimatePresence } from "framer-motion";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function Rejectedpayments9() {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryaccountstoken");
  const { selectedDistrict } = useContext(ContextBoard);

  useEffect(() => {
    if (!selectedDistrict) {
      navigate("/secondary-accounts-dashboard-class-ix");
      return;
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/FORejectedPayment_CL9`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ districtcode: selectedDistrict }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        // console.log("Fetched data:", data);
        setTableData(data.data.foRejectedPayment_status);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching table data:", error);
      }
    };
    fetchData();
  }, []);

  const filteredData = tableData.filter((row) => {
    const query = searchQuery.toLowerCase();

    return (
      row.schooL_NAME?.toLowerCase().includes(query) ||
      row.schooL_CODE?.toString().toLowerCase().includes(query) ||
      row.blocK_NAME?.toLowerCase().includes(query) ||
      row.sC_ADDRESS?.toLowerCase().includes(query) ||
      row.challaN_NO?.toString().toLowerCase().includes(query) ||
      row.paymenT_MODE?.toLowerCase().includes(query) ||
      row.district?.toLowerCase().includes(query) ||
      row.nO_OF_STUDENT?.toString().toLowerCase().includes(query) ||
      row.paymenT_DATE_TIME?.toString().toLowerCase().includes(query) ||
      row.fO_REJECT_DATE_TIME?.toString().toLowerCase().includes(query) ||
      row.fO_REMARKS?.toString().toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredData.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const generateExcel = async () => {
    if (!tableData.length) {
      Swal.fire("No Data", "No student data available for export.", "warning");
      return;
    }

    const token = sessionStorage.getItem("secondaryaccountstoken");
    if (!token) {
      Swal.fire(
        "Authentication Error",
        "Token is missing. Please log in.",
        "error"
      );
      return;
    }

    try {
      setLoading(true);

      const now = new Date();
      const formattedDateTime = `${now
        .getDate()
        .toString()
        .padStart(2, "0")}-${(now.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${now.getFullYear()} ${now
            .getHours()
            .toString()
            .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now
              .getSeconds()
              .toString()
              .padStart(2, "0")}`;

      const ws = XLSX.utils.aoa_to_sheet([
        ["Total Rejected Payments"],
        // ["Challan No:", newchallan],
        // ["Challan Generation Date & Time:", newdatetime],
        ["Total Rejected Payments Print Date & Time:", formattedDateTime],
        [],
        [],
        [
          "Sl. No",
          "District",
          "School Code",
          "School Name",
          "Challan No.",
          "No. of Students",
          "Challan Generation date & Time",
          "Payment Mode",
          "Rejection Date & Time",
        ],
      ]);

      const rows = tableData.map((student, index) => [
        index + 1,
        student.district || "",
        student.schooL_CODE || "",
        student.schooL_NAME || "",
        student.challaN_NO || "",
        student.nO_OF_STUDENT || "",
        student.paymenT_DATE_TIME || "",
        student.paymenT_MODE || "",
        student.fO_REJECT_DATE_TIME || "",
      ]);

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

      ws["!cols"] = [
        { wch: 8 }, // Sl. No
        { wch: 25 }, // Name
        { wch: 15 }, // Gender
        { wch: 15 }, // Caste
        { wch: 15 }, // Category
        { wch: 15 }, // Exam Fees
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Checklist");

      const fileName = `Total_Rejected_Payments.xlsx`;
      XLSX.writeFile(wb, fileName);

      setLoading(false);

      Swal.fire({
        title: "Success",
        text: "Excel file has been generated successfully!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error generating Excel:", error);
      setLoading(false);
      Swal.fire(
        "Error",
        "An error occurred while generating the checklist.",
        "error"
      );
    }
  };

  return (
    <>
      <div class="container-scroller">
        <Navbar />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user"></i>&nbsp; Total Rejected Payments
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="accounts-dashboard"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/secondary-accounts-dashboard-class-ix");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Total Rejected Payments</li>
                    </ol>
                    <h3></h3>
                  </section>
                </div>
              </div>
              <div className="row" style={{ padding: "0px" }}>
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row mb-2">
                        {/* <div className="col-md-12 text-right">
                          {tableData.length > 0 ? (
                            <button
                              onClick={generateExcel}
                              className="btn btn-success btn-sm"
                            >
                              {" "}
                              <i class="fa fa-file-excel"></i> Export to Excel
                            </button>
                          ) : (
                            ""
                          )}
                        </div> */}
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                              <label
                                htmlFor="rowsPerPage"
                                className="me-2 mb-0"
                              >
                                Rows:
                              </label>
                              <div style={{ width: "250px" }}>
                                <select
                                  id="rowsPerPage"
                                  className="form-select form-select-sm"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                  style={{
                                    width: "80px", // or adjust as needed (80–120px)
                                    paddingRight: "2rem", // ensures space for the dropdown arrow
                                  }}
                                >
                                  {[10, 20, 50, 100, 500].map((num) => (
                                    <option key={num} value={num}>
                                      {num}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div style={{ width: "200px" }}>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                              <thead>
                                <tr
                                  className="table-info"
                                  style={{ textWrap: "nowrap" }}
                                >
                                  <th>Sl. No</th>
                                  <th>District</th>
                                  <th>School Code</th>
                                  <th>School Name</th>
                                  <th>Challan Number</th>
                                  <th>No. of Students</th>
                                  <th>Payment Date & Time</th>
                                  <th>Payment Mode</th>
                                  <th>Rejection Date & Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentItems.length > 0 ? (
                                  currentItems.map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item.district}</td>
                                      <td>{item.schooL_CODE}</td>
                                      <td>{item.schooL_NAME}</td>
                                      <td>{item.challaN_NO}</td>
                                      <td>{item.nO_OF_STUDENT}</td>
                                      <td>
                                        <span
                                          className="badge badge-primary border border-primary"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {item.paymenT_DATE_TIME}
                                        </span>
                                      </td>
                                      <td>{item.paymenT_MODE}</td>
                                      <td>
                                        <span
                                          className="badge badge-danger border border-danger"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {item.fO_REJECT_DATE_TIME}
                                        </span>
                                        <br />
                                        <br />
                                        <b>Remarks :</b> {item.fO_REMARKS}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="9"
                                      className="text-center text-muted"
                                    >
                                      No data found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                              {/* <tfoot>
                                                    <tr>
                                                        <td colSpan={9} style={{padding: "5px"}}>
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                style={{ marginRight: "15px" }}
                                                            >
                                                                <i className="fa fa-check"></i>&nbsp;Approve
                                                            </button>
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                style={{ marginRight: "15px" }}
                                                            >
                                                                <i className="fa fa-times"></i>&nbsp;Reject
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tfoot> */}
                            </table>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div>
                              Showing {(currentPage - 1) * perPage + 1} to{" "}
                              {Math.min(indexOfLastItem, filteredData.length)}{" "}
                              of {filteredData.length} entries
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <MdOutlineKeyboardDoubleArrowLeft
                                onClick={() => {
                                  if (currentPage > 1) setCurrentPage(1);
                                }}
                                style={{
                                  cursor:
                                    currentPage > 1 ? "pointer" : "not-allowed",
                                  opacity: currentPage > 1 ? 1 : 0.5,
                                }}
                              />

                              <MdOutlineKeyboardArrowLeft
                                onClick={() => {
                                  if (currentPage > 1)
                                    setCurrentPage((prev) => prev - 1);
                                }}
                                style={{
                                  cursor:
                                    currentPage > 1 ? "pointer" : "not-allowed",
                                  opacity: currentPage > 1 ? 1 : 0.5,
                                }}
                              />

                              <span>
                                Page {currentPage} of {totalPages}
                              </span>

                              <MdOutlineKeyboardArrowRight
                                onClick={() => {
                                  if (currentPage < totalPages)
                                    setCurrentPage((prev) => prev + 1);
                                }}
                                style={{
                                  cursor:
                                    currentPage < totalPages
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity: currentPage < totalPages ? 1 : 0.5,
                                }}
                              />

                              <MdOutlineKeyboardDoubleArrowRight
                                onClick={() => {
                                  if (currentPage < totalPages)
                                    setCurrentPage(totalPages);
                                }}
                                style={{
                                  cursor:
                                    currentPage < totalPages
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity: currentPage < totalPages ? 1 : 0.5,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Rejectedpayments9;
